import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ChannelModel } from '../../shared/models/channel';
import { PointExpiryRuleModel } from '../../shared/models/point-expiry-rule';
import { RegionModel } from '../../shared/models/region';
import { StateModel } from '../../shared/models/state';
import { PosmAudityTypesModel, VisibilityModel } from '../../shared/models/visibility';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { StateProvider } from '../../shared/providers/state.provider';
import { VisibilityProvider } from '../../shared/providers/visibility.provider';

@Component({
  selector: 'app-add-edit-point-expiry-rule',
  templateUrl: './add-edit-point-expiry-rule.component.html',
  styleUrls: ['./add-edit-point-expiry-rule.component.scss']
})
export class AddEditPointExpiryRuleComponent implements OnInit {

  channels: ChannelModel[];
  regions: RegionModel[];
  states: StateModel[];
  _parameters: any;
  id: number;
  _form: FormGroup;
  submitted = false;
  @Input() model: PointExpiryRuleModel = new PointExpiryRuleModel();
  posmElements: VisibilityModel[];
  comparisonOperators: any[];
  constructor(
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    public adminDataProvider: AdminDataProvider,
    public channelProvider: ChannelProvider,
    public stateProvider: StateProvider,
    public regionProvider: RegionProvider,
    private router: Router,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    private formateDate: DateFormateService,
  ) {
    this._form = this.formBuilder.group({
      rule_name: ["", Validators.required],
      conditional_operator: ["", Validators.required],
      // expiry_point: ["", Validators.required],
      rule_point: ["", Validators.required],
      region_id: ["", Validators.required],
      state_code: ["", Validators.required],
      channel_id: ["", Validators.required],
      end_date: ["", Validators.required],
      exipry_date: ["", Validators.required],
      start_date: ["", Validators.required],
    });
  }

  ngOnInit() {

    this.comparisonOperators = [
      { 'id': "=", "name": "=" },
      { 'id': ">", "name": ">" },
      { 'id': "<", "name": "<" },
      { 'id': ">=", "name": ">=" },
      { 'id': "<=", "name": "<>" },
    ];


    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.id = Number.parseInt(params["id"]);
          this.getPosmAuditTypes(this.id);
        }
      }
    });
    this.getStateList();
  }

  getPosmAuditTypes(id) {
    this.apiService
      .getHeaders(this.apiConfig.getPointExipryRule + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.model = res.body.data as PointExpiryRuleModel;
          let dates = {
            start: this.model.start_date.split("-"),
            end: this.model.end_date.split("-"),
            expiry: this.model.exipry_date.split("-"),
          };
          let startDate = {
            year: parseInt(dates.start[0]),
            month: parseInt(dates.start[1]),
            day: parseInt(dates.start[2]),
          };
          let expiryDate = {
            year: parseInt(dates.expiry[0]),
            month: parseInt(dates.expiry[1]),
            day: parseInt(dates.expiry[2]),
          };
          let endDate = {
            year: parseInt(dates.end[0]),
            month: parseInt(dates.end[1]),
            day: parseInt(dates.end[2]),
          };
          this.model.endDate = endDate;
          this.model.startDate = startDate;
          this.model.expiryDate = expiryDate;
          this.stateFilteredByRegion = this.states.filter(
            (i) => i.region_id == this.model.region_id
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getStateList(): void {
    this.apiService
      .getHeaders(this.apiConfig.configGetStates)
      .subscribe((res: any) => {
        this.states = res.body.data as StateModel[];
        this.states.forEach((s) => {
          s.id = s.state_code;
        });
        this.stateFilteredByRegion = this.states.filter(
          (i) => i.region_id == this.model.region_id
        );
      });
  }

  stateFilteredByRegion: StateModel[];

  onChangeRegion(item) {
    this.stateFilteredByRegion = this.states.filter(
      (s) => s.region_id == item && s.state_year == 2021
    );
  }


  // convenience getters for easy access to form fields
  get f() {
    return this._form.controls;
  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
    this.states = this.stateProvider.state;
    this.channels = this.channelProvider.channels;
  }

  ngDestroy() {
    this._parameters.unsubscribe();
  }

  onSubmit() {
    this.submitted = true;
    if (this._form.invalid) {
      return;
    }
    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);
    this.model.exipry_date = this.formateDate.formateDate(this.model.expiryDate);
    if (this.model.id != null) {
      this.updatePosmTemplate();
    } else {
      this.createPosmTemplate();
    }
  }

  createPosmTemplate() {
    this.apiService
      .post(this.apiConfig.createPointExipryRule, this.model)
      .subscribe((res: any) => {
        if (res.body.status) {
          this.alertService.success(res.body.data.message);
          this.router.navigateByUrl("/hubAdmin/point-expiry-rules");
        }
      });
  }

  updatePosmTemplate() {
    this.apiService
      .put(
        this.apiConfig.updatePointExipryRule + "?id=" + this.model.id,
        this.model
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.alertService.success(res.data.message);
          this.clearSuccess();
        }
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }


}
